import { authHeaderNoToken, handleResponse } from "../helper/auth-header";

export default class LoginService {
  ControllerName = "Login";

  async CreateFeedback(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateFeedback`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async CheckUser(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeaderNoToken(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CheckUser`;

    let data;
    try {
      const response = await fetch(url, requestOptions);
      data = await handleResponse(response, { url, ...requestOptions });
    } catch (error) {}
    return data;
  }
}
